import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Brainerd",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Brainerd Minnesota north central lakes country, historic downtown with the iconic water tower visible, Mississippi River flowing through the city, residential neighborhoods with lake homes and wooded lots, Paul Bunyan and Babe the Blue Ox statue visible at the Paul Bunyan Land amusement area, surrounding forest and lakes landscape, Gull Lake and Whitefish Lake visible in the distance, daytime photography with clear sky, professional aerial photography, no readable signs or text",
  heroImageSeq: "brainerd-mn-hero-2026",
  heroDescription:
    "Canadian fishing trip in four weeks and your passport expired? European cruise with six weeks to spare? Summer cabin rental in Canada with three weeks notice? We help Brainerd residents — from Crow Wing County lake families and resort owners to Paul Bunyan Land visitors and north central Minnesota outdoor enthusiasts — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "46.3580; -94.2008",
  geoPlacename: "Brainerd, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/brainerd/",
  localAreaTitle: "Serving Brainerd & North Central Lakes Country",
  localAreaText: [
    "Brainerd, Minnesota is the gateway to the north central lakes country and the largest city in Crow Wing County. Located at the intersection of Highways 210 and 371, the city serves as the commercial, medical, and recreational hub for a vast lake region that includes Gull Lake, Whitefish Lake, Pelican Lake, and hundreds of smaller lakes. The Brainerd Lakes Area is one of Minnesota's most popular vacation destinations.",
    "The city's economy is driven by tourism, retail, healthcare (Essentia Health-St. Joseph's Medical Center), and manufacturing. The historic downtown along Laurel Street features local shops and restaurants. The famous Paul Bunyan and Babe the Blue Ox statue at Paul Bunyan Land has been a roadside attraction since the 1950s, drawing visitors from across the Midwest.",
    "Brainerd's location along the Mississippi River and the surrounding lake country creates a unique outdoor recreation culture. Residents and seasonal visitors engage in fishing, boating, hunting, snowmobiling, and cross-country skiing. The International Eelpout Festival on Leech Lake is a famous winter event. Many lake families maintain cabins for generations, creating deep community ties to the area.",
    "The north central lakes region attracts seasonal residents from the Twin Cities, Chicago, and beyond. These 'lake families' often plan international trips between seasons — Caribbean cruises during winter, European travel during spring or fall, and Canadian fishing trips during summer. The seasonal nature of lake life creates predictable travel patterns with compressed timelines.",
  ],
  nearbyCities: [
    { name: "Brainerd", zips: "56401" },
    { name: "Baxter", zips: "56425" },
    { name: "Nisswa", zips: "56468" },
    { name: "Pequot Lakes", zips: "56472" },
    { name: "Crosslake", zips: "56442" },
    { name: "Staples", zips: "56479" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Brainerd home or cabin in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Brainerd area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Brainerd & North Central Lakes Country",
  serviceAreaDescription: "Serving Crow Wing County and north central Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Brainerd, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a Brainerd area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Brainerd lake families get passports before a Canadian fishing trip?",
      a: "Absolutely. Canadian fishing trips are one of the most common reasons Brainerd residents need expedited passports. We regularly process expedited renewals and new applications for lake families planning trips to Canada — as fast as 2–9 business days.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Brainerd?",
      a: "No — most Brainerd travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Brainerd. You can ship from FedEx or UPS locations nearby in Brainerd or Baxter.",
    },
    {
      q: "My family is planning a Caribbean cruise for winter. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Many lake families plan cruises during the off-season — start as soon as you book.",
    },
    {
      q: "What if I need a passport for a last-minute Canadian fishing trip?",
      a: "Canadian fishing trips are often planned with short notice when the fish are biting. We can process your passport as fast as 24 hours with proof of travel. Our emergency service is designed for exactly these situations.",
    },
    {
      q: "Are there passport acceptance facilities near Brainerd?",
      a: "The Brainerd Post Office, Baxter Post Office, and Staples Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "The Anderson Family",
      location: "Brainerd, MN",
      rating: 5,
      text: "We've been planning our Canadian fishing trip to Lake of the Woods for months and discovered my passport had expired two weeks before we were supposed to leave. Fast Passport Center processed my renewal in four business days. We made our trip and caught the biggest walleye of our lives. Thank you for saving our vacation.",
      service: "Emergency Renewal",
    },
    {
      name: "Mike S.",
      location: "Brainerd, MN",
      rating: 5,
      text: "I own a resort on Gull Lake and planned a Caribbean cruise for the off-season. My passport was expired. Fast Passport Center processed my renewal in five business days. The service was excellent and I made my cruise. I'll recommend them to all my resort guests.",
      service: "Passport Renewal",
    },
    {
      name: "The Johnson Family",
      location: "Brainerd, MN",
      rating: 5,
      text: "Our family planned a European trip to visit Norway where our ancestors came from. We had six weeks. Fast Passport Center processed all four family passports in seven business days. The checklist was incredibly helpful and we had a wonderful trip connecting with our roots. We'll use them again.",
      service: "Family Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Duluth", href: "/cities/duluth-mn" },
    { name: "St. Cloud", href: "/cities/st-cloud" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Mankato", href: "/cities/mankato" },
    { name: "Rochester", href: "/cities/rochester-mn" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Brainerd",
  introDescription: "Fast passport processing for Brainerd and north central lakes country travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Brainerd and north central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Brainerd Post Office",
      address: "422 Laurel St, Brainerd, MN 56401",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(218) 829-3315",
      notes: "Primary passport acceptance facility for Brainerd and Crow Wing County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Baxter Post Office",
      address: "7035 Glory Rd, Baxter, MN 56425",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(218) 829-4740",
      notes: "Serves Baxter and west Brainerd area. Full passport services.",
    },
    {
      name: "Staples Post Office",
      address: "212 4th St NE, Staples, MN 56479",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(218) 894-2620",
      notes: "Todd County. Full passport services. Convenient for south Brainerd residents.",
    },
    {
      name: "Little Falls Post Office",
      address: "88 1st Ave SE, Little Falls, MN 56345",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(320) 632-2951",
      notes: "Morrison County. Full passport services. Convenient for south Crow Wing County residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Brainerd", address: "14175 Edgewood Dr, Baxter, MN 56425", hours: "Call for hours" },
    { name: "CVS Pharmacy — Brainerd", address: "16021 Highland Ave, Baxter, MN 56425", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Baxter", address: "Baxter commercial area", hours: "Call for hours" },
    { name: "Walmart — Brainerd", address: "7295 County Rd 77, Brainerd, MN 56401", hours: "Call for hours" },
    { name: "FedEx Office — Brainerd", address: "Brainerd commercial area", hours: "Call for hours" },
    { name: "The UPS Store — Baxter", address: "Baxter commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Crow Wing County DVS Office",
      address: "304 Laurel St, Brainerd, MN 56401",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Crow Wing County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Staples DVS Office",
      address: "Todd County area, Staples, MN",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Todd County DVS. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BRD",
      name: "Brainerd Lakes Regional Airport",
      distance: "About 5 miles from Brainerd — 10 minutes by car",
      address: "16384 Airport Rd, Brainerd, MN 56401",
      note: "Regional airport for Brainerd residents. Direct flights to Minneapolis. Private and charter flights available. No commercial international service.",
      flightUrl: "https://brainerdairport.com/",
      flightLabel: "Brainerd Lakes Regional Airport",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 130 miles from Brainerd — 2 hours by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Major international airport for Brainerd residents. Full international flight service. Access via Highway 371 and I-94.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "Canadian Fishing & Outdoor Travel",
      subtitle: "Lake families planning Canadian fishing trips and outdoor adventures",
      content:
        "Brainerd and the north central lakes region is the gateway to Canadian fishing. Lake families regularly plan fishing trips to Ontario, Manitoba, and Lake of the Woods. These trips are often planned when the fish are biting — sometimes with only 2–3 weeks notice. Canadian travel requires a valid passport or passport card.",
      tip: "Canadian fishing trips are common spring through fall. A passport card works for land and sea crossings to Canada. Keep yours current.",
      icon: "ri-ship-line",
    },
    {
      title: "Winter Caribbean & Mexico Escapes",
      subtitle: "Lake families escaping Minnesota winters for warm destinations",
      content:
        "Brainerd lake families often plan Caribbean cruises and Mexico resort vacations during the winter off-season. These trips are booked during fall and early winter, with departure dates typically in January through March. Families often discover passport issues when preparing for winter travel.",
      tip: "Winter Caribbean trips are common January through March. Check passport validity in October for winter travel.",
      icon: "ri-sun-line",
    },
    {
      title: "European Heritage & Cultural Travel",
      subtitle: "Scandinavian and German heritage trips for lake country families",
      content:
        "Many Brainerd families trace their roots to Scandinavian and German immigrants who settled in the north central lakes region. Heritage trips to Norway, Sweden, and Germany are popular among multi-generational families, often planned for summer or during the off-season.",
      tip: "European heritage trips are often planned 6+ months in advance. Start passport renewals early to avoid last-minute stress.",
      icon: "ri-earth-line",
    },
    {
      title: "Seasonal Resort & Tourism Travel",
      subtitle: "Resort owners and tourism workers with international travel needs",
      content:
        "Brainerd's resort and tourism industry attracts seasonal workers and resort owners who travel internationally for industry conferences, training, and personal vacations. The seasonal nature of the business creates predictable travel patterns during the off-season months.",
      tip: "Resort owners should maintain passport validity year-round. International travel often happens during the off-season.",
      icon: "ri-hotel-line",
    },
  ],
  destinations: [
    {
      name: "Canada",
      context: "Fishing trips to Ontario, Manitoba, and Lake of the Woods for Brainerd lake families",
      urgency: "Fishing trips are often planned when conditions are right — passport must be current",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises and all-inclusive resorts for winter escapes from Minnesota's cold",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Resort vacations for Brainerd families during winter and spring break",
      urgency: "Resort packages are often booked 3–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Norway & Sweden",
      context: "Heritage travel for Brainerd's Scandinavian community",
      urgency: "Summer Scandinavian travel is planned months in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Alaska",
      context: "Fishing and adventure travel for outdoor enthusiasts from the lakes region",
      urgency: "Alaska fishing trips are often planned during the off-season with specific dates",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Heritage trips for German-American families and beer tourism",
      urgency: "Heritage trips and Oktoberfest travel are often planned 6+ months ahead",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "45%", label: "of Brainerd expedited requests are Canadian fishing trips with weather-dependent timing" },
    { stat: "3–4 Weeks", label: "most common advance notice when lake families discover passport issues before a trip" },
    { stat: "Nov–Mar", label: "peak travel season for Caribbean cruises and Mexico escapes during winter months" },
    { stat: "5–7 Days", label: "typical expedited processing time for Brainerd clients choosing our recommended option" },
  ],
};

export default function BrainerdMNPage() {
  return <CityPage data={data} />;
}